<div class="recent-activity-section" fxFlexFill fxLayout="row" fxLayoutAlign="space-evenly center">
  <div class="spacer"></div>
  <button kendoButton [icon]="'chevron-right'"></button>
  <div class="spacer"></div>
</div>
